const plans = {
  trial: 'trial',
  free: 'free',
  premium: 'premium',
}
export type Plans = keyof typeof plans | null;

/**
 * トライアルかどうかを返す
 * @param serviceContractType 
 * @returns 
 */
 export const isTrial = (serviceContractType?: Plans) => {
  if(!serviceContractType || !plans[serviceContractType]) throw new Error('invalid service contract type');
  return "trial" === serviceContractType;
}

/**
 * 再トライアル（トライアル終了後の再獲得キャンペーン等）かどうかを返す
 * @param serviceContractTypeDetail
 * @returns
 */
export const isReTrial = (serviceContractTypeDetail?: 'retrial' | null) => {
  return serviceContractTypeDetail === 'retrial';
}

/**
 * フリープランかどうかを返す
 * @param serviceContractType 
 * @returns 
 */
export const isFree = (serviceContractType?: Plans) => {
  if(!serviceContractType || !plans[serviceContractType]) throw new Error('invalid service contract type');
  return "free" === serviceContractType;
}

/**
 * プレミアムプランかどうかを返す
 * @param serviceContractType 
 * @returns 
 */
export const isPremium  =(serviceContractType?: Plans) => {
  if(!serviceContractType || !plans[serviceContractType]) throw new Error('invalid service contract type');
  return "premium" === serviceContractType;
}
